import { Box, Button, List, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import {
  PriceDisplay,
  PricingCardProps,
  PricingDetail,
  SelectTutorOptions,
} from "./PricingCard";
import Pluralize from "pluralize";

type MobilePricingCardProps = PricingCardProps & {
  canSelectTeacher: boolean;
  selectedOption: any;
};

const MobilePricingCard: React.FC<MobilePricingCardProps> = (props) => {
  const {
    onClick,
    features,
    duration = "per month",
    lessons = 12,
    name,
    description,
    price,
    popular,
    isLoading,
    selectedCurrency,
    teacherNoOptions,
    teacherStore,
    canChangeNoOfTutors,
    // separateTeacherInfo,
    teachingOptions,
    canSelectTeacher,
    selectedOption,
    ...rest
  } = props;

  return (
    <Box display={{ base: "block", lg: "none" }}>
      <Box
        // borderBottom="1px solid #EFF1F5"
        mb="2rem"
      >
        <Box display={"flex"} alignItems={"center"}>
          <Text fontSize="xl" fontWeight="medium">
            {name} Plan
          </Text>
          {popular && (
            <Text
              marginLeft={"1.5rem"}
              color="blue.500"
              fontFamily={"Shantell sans"}
              fontWeight="semibold"
              fontSize={"sm"}
            >
              Most popular
            </Text>
          )}
        </Box>
      </Box>
      <Box my="1rem">
        <PriceDisplay currency={selectedCurrency.symbol} price={price} />

        <Box
          display="inline-flex"
          mx="auto"
          fontSize="sm"
          fontWeight="regular"
          textTransform={"capitalize"}
          opacity="0.7"
        >
          {duration} ({Pluralize("lesson", lessons, true)})
        </Box>
      </Box>
      {canSelectTeacher && (
        <>
          <Box
            pb={"1rem"}
            pt="1rem"
            borderTop="1px solid #EFF1F5"
            borderBottom="1px solid #EFF1F5"
            mx={["-6", "-10"]}
            px={["6", "10"]}
          >
            <Text opacity={"0.7"} textTransform="capitalize" mb="0.5rem">
              Select teacher arrangement
            </Text>
            <SelectTutorOptions
              options={teacherNoOptions}
              defaultValue={teacherStore.teacherOption}
              onTeacherNumberSelect={(o) => {
                teacherStore.updateField({
                  teacherKind: o,
                });
              }}
            />
          </Box>
          {selectedOption ? selectedOption.jsx(true, () => {}) : null}
        </>
      )}
      <Box mt={{ base: 4, sm: 4 }}>
        <Button
          minH="2rem"
          rounded={"md"}
          fontWeight="bold"
          fontSize={"sm"}
          background={"blue.500"}
          textColor={"#fff"}
          borderTop={"none"}
          mt="2"
          w="100%"
          isLoading={isLoading}
          loadingText="Processing"
          onClick={onClick}
          display="flex"
          justifyContent={"center"}
          _hover={{
            background: "blue.500",
            opacity: "0.6",
          }}
        >
          Select Plan
        </Button>
      </Box>
      <Box mt={"1.5rem"} mb="1rem">
        <List stylePosition="outside" mt="1rem" opacity={"0.7"} spacing={4}>
          {features.map((feature, idx) => (
            <PricingDetail key={idx}>
              {feature}
            </PricingDetail>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default MobilePricingCard;
